<template>
  <div>
    <div class="vx-row justify-center">
      <div class="mb-4">
        <label class="vs-input--label pl-1">Месяц:</label>
        <elsa-v-datepicker
          v-model="selectedDate"
          view-format="LLLL yyyy"
          :clearable="false"
        />
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full flex justify-center">
        <vs-button
          v-if="isInvoicesShown"
          id="toggle-shown-button"
          type="border"
          class="vs-con-loading__container"
          :disabled="loading || isOldQuarter"
          @click="onToggleShown"
        >
          Скрыть
        </vs-button>
        <vs-button
          v-else
          id="toggle-shown-button"
          type="border"
          class="vs-con-loading__container"
          :disabled="loading"
          @click="onToggleShown"
        >
          Показать
        </vs-button>
      </div>
    </div>
  </div>
</template>

<script>
import notifyHttpError      from "@/mixins/notifyHttpError";
import modalContext         from "@/mixins/modalContext";
import quarterDisabledDates from "@/mixins/quarterDisabledDates";
import startOfMonth         from 'date-fns/startOfMonth';

export default {
  name:       "InvoicesToggleShownPopup",
  mixins:     [notifyHttpError, modalContext, quarterDisabledDates],
  components: {},
  data() {
    return {
      loading:         true,
      isInvoicesShown: null,
    };
  },
  computed: {
    selectedDate: {
      get() {
        return new Date(this.$store.getters['appUser/selectedDate']) || null;
      },
      set( value ) {
        this.$store.dispatch('appUser/SET_DATE', value);
      },
    },

    selectedHouseId() {
      return this.$store.getters['appUser/selectedHouse'].id;
    },

    isOldQuarter() {
      const date = new Date(this.selectedDate);
      return startOfMonth(this.quarterDisabledDates.to) > startOfMonth(date);
    },
  },
  methods:  {
    loadIsInvoicesShown() {
      this.loading = true;
      this.getIsInvoicesShown().then(( isInvoicesShown ) => {
        this.isInvoicesShown = isInvoicesShown;
        this.loading = false;
      });
    },

    getIsInvoicesShown() {
      const params = {
        buildings_id: this.selectedHouseId,
        month:        this.$options.filters.formatDate(this.selectedDate),
      };

      return this.$http.get('kv_show_status', { params }).then(
        ( { data } ) => {
          if (!data.length) return false;

          let isInvoicesShown = true;
          data.forEach(status => {
            isInvoicesShown = isInvoicesShown && status.is_shown;
          });
          return isInvoicesShown;
        },
        this.notifyHttpError,
      );
    },

    updateLoading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#toggle-shown-button',
          scale:     .5,
        });

      } else {
        this.$vs.loading.close('#toggle-shown-button > .con-vs-loading');
      }
    },

    toggleShown() {
      let params = {
        buildings_id: this.selectedHouseId,
        month:        this.$options.filters.formatDate(this.selectedDate),
        show_kv:      !this.isInvoicesShown,
      };

      this.loading = true;
      return this.$http.put('pdf', params).then(
        () => {
          this.modalResolve();
        },
        this.notifyHttpError,
      );
    },

    onToggleShown() {
      this.$vs.dialog({
        type:       'confirm',
        color:      'primary',
        title:      'Подтверждение',
        text:       `Вы уверены что хотите ${this.isInvoicesShown ? 'скрыть' : 'показать'} квитанции для пользователя?`,
        acceptText: 'Да',
        cancelText: 'Нет',
        accept:     this.toggleShown,
      });
    },
  },
  mounted() {
    this.loadIsInvoicesShown();
    this.updateLoading();
  },
  beforeDestroy() {
  },
  watch: {
    loading() {
      this.updateLoading();
    },
    selectedDate() {
      this.loadIsInvoicesShown();
    },
  },
};
</script>

<style lang="scss" module>
.button {
  width: 200px;
}
</style>
